import gql from 'graphql-tag';

export const REVIEWS_QUERY = {
  es: gql`
    query ReviewsCollection {
      reviews(sort: "createdAt:desc") {
        id
        name
        review: review_es
        rating
        avatar {
          url
        }
      }
    }
  `,
  en: gql`
    query ReviewsCollection {
      reviews(sort: "createdAt:desc") {
        id
        name
        review: review_en
        rating
        avatar {
          url
        }
      }
    }
  `
};
